import * as React from 'react';

import ScrollableView from '../../scrollable-view';
import SidebarItem, { SidebarItemProps } from '../sidebar-item';
import { Root, styles } from './styled';


type SidebarItem = {
	name: string;
	sysName: string;
	path: string;
}

type SidebarProps = {
	items: Array<SidebarItem>;
	renderItemIcon: SidebarItemProps['renderIcon'];
}

const Sidebar: React.SFC<SidebarProps> = ({ items, renderItemIcon, ...rest }) => {

	return (
		<Root {...rest}>
			<ScrollableView style={styles.scrollableView}>
				{
					items.map(route => {
						return (
							<SidebarItem
								key={route.path}
								path={route.path}
								sysName={route.sysName}
								name={route.name}
								renderIcon={renderItemIcon}
							/>
						);
					})
				}
			</ScrollableView>
		</Root>
	);
}

Sidebar.displayName = 'Sidebar';
Sidebar.defaultProps = {
	items: [],
};

export default Sidebar;
